export default "__VITE_ASSET__Bui2SYC7__"